export default "__VITE_ASSET__BVUBvdLv__"